import { EscapeHtmlPipe } from "./sanitizer.pipe";
import { SecuredImageComponent } from "./../../shared/secured-image.component";
import { FilePreviewDirective } from "./../main/common/file-preview.directive";
import { HeaderInterceptor } from "./../../utils/header.interceptor";

import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Routes } from "@angular/router";

import { CommonModule, NgOptimizedImage } from "@angular/common";
import { ModalModule } from "ngx-bootstrap/modal";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { MomentModule } from "ngx-moment";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { AutosizeModule } from "ngx-autosize";

// Components
// import { ConversationsComponent } from "./conversations.component";
import { ChatComponent } from "./chat/chat.component";
import { MessageBubbleComponent } from "./message-bubble/message-bubble.component";
import { TrackedItemBubbleComponent } from "./tracked-item-bubble/tracked-item-bubble.component";

// Modals Components
import { ChatSettingsModalComponent } from "./modals/chat-settings-modal.component";
import { CreateConversationModalComponent } from "./modals/create-conversation-modal.component";
import { CommentsModalComponent } from "./modals/comments-modal.component";
import { NewTrackedItemModalComponent } from "./modals/new-tracked-item-modal.component";
import { NotificationSettingsModalComponent } from "./../main/accountant/modals/notification-settings-modal.component";

// Services
import { ConversationsService } from "./conversations.service";

// Other imports
import { OrderByPipe } from "../main/common/order-by.pipe";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";

// Directives
import { InitialsDirective } from "../../utils/initials.directive";
import { NgxLinkifyjsModule } from "ngx-linkifyjs-v2";
import { FilePreviewComponent } from "./../main/common/file-preview.component";

import {
  HttpClient,
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { UploadProgressBarComponent } from "src/app/utils/upload-progress-bar/upload-progress-bar.component";
import { PickerComponent } from "@ctrl/ngx-emoji-mart";
import { EmojiComponent } from "@ctrl/ngx-emoji-mart/ngx-emoji";
import { ShowOwnerNamesPipe } from "./message-bubble/show-names.pipe";

const routes: Routes = [];

@NgModule({
  exports: [
    FilePreviewComponent,
    ChatComponent,
    MessageBubbleComponent,
    InitialsDirective,
    FilePreviewDirective,
    MomentModule,
    EscapeHtmlPipe,
    UploadProgressBarComponent,
  ],
  imports: [
    EmojiComponent,
    PickerComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PdfViewerModule,
    ModalModule.forRoot(),
    TooltipModule.forRoot(),
    MomentModule,
    AutosizeModule,
    TypeaheadModule.forRoot(),
    BsDropdownModule.forRoot(),
    NgxLinkifyjsModule.forRoot(),
    NgOptimizedImage,
    ChatComponent,
    ChatSettingsModalComponent,
    CreateConversationModalComponent,
    CommentsModalComponent,
    NewTrackedItemModalComponent,
    MessageBubbleComponent,
    InitialsDirective,
    FilePreviewDirective,
    FilePreviewComponent,
    OrderByPipe,
    NotificationSettingsModalComponent,
    SecuredImageComponent,
    EscapeHtmlPipe,
    UploadProgressBarComponent,
    ShowOwnerNamesPipe,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeaderInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class ConversationsModule {}
